/**
 * Момент цитаты критерия в записи (#862).
 *
 * Нумерация реплик и проверка цитаты — общие с отчётом в CRM
 * (`buildEvidenceMomentIndex` / `momentOfEvidence` в `@aica/core`, #2516):
 * своя копия здесь молча разошлась бы с промптом шага оценки. Здесь — только
 * перевод времени хранимой диаризации (миллисекунды) в секунды плеера.
 *
 * **Нумерация строится ОДИН раз на набор сегментов.** Прежняя редакция считала
 * её внутри рендера на каждую цитату, а панель перерисовывается на каждый кадр
 * воспроизведения (`onTimeUpdate` → `setCurrentTime`): на двадцатиминутном
 * звонке это тысячи разборов сегментов в секунду — заметное подвисание ровно в
 * тот момент, когда пользователь слушает цитату (находка `/code-review`).
 */
import {
  buildEvidenceMomentIndex,
  momentOfEvidence,
  type EvidenceMomentIndex,
} from '@aica/core/call-criteria';

export { momentOfEvidence };

/** Минимум, который нужен поиску момента: начало реплики (мс) и её текст. */
export interface CriteriaSegment {
  start: number;
  text?: string;
}

/** Номер реплики → её момент в секундах. Строится один раз на набор сегментов. */
export type CriteriaMomentIndex = EvidenceMomentIndex;

/**
 * Построить отображение «номер реплики → момент записи» (секунды).
 *
 * Вызывать через `useMemo` по ссылке на сегменты: разбор каждого сегмента
 * стоит дорого, а результат зависит только от них.
 */
export function buildCriteriaMomentIndex(
  segments: readonly CriteriaSegment[] | undefined
): CriteriaMomentIndex {
  const index = new Map<number, { start: number; text: string }>();
  buildEvidenceMomentIndex(segments).forEach((moment, turn) => {
    index.set(turn, { start: moment.start / 1000, text: moment.text });
  });
  return index;
}
